import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosChallenges } from "./axios";

export const useDeleteCandidateChallenge = () => {
  const [state, execute, cancel] = axiosChallenges<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (challengeId: ObjectId, candidateId: ObjectId) =>
      execute({
        url: `/${challengeId}/candidate/${candidateId}`,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
